/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Component } from '@angular/core';
import { LabelWithCurrencyInnerHtmlComponent } from './label-with-currency-inner-html.component';

@Component({
    selector: 'column-header-with-currency',
    templateUrl: './label-with-currency-inner-html.component.html',
    standalone: false
})

/// This component is designed to be used in where a column header is using the InnerHTML property with a currency symbol
/// Using this component will ensure that the header has the correct styling
export class ColumnHeaderWithCurrencyComponent extends LabelWithCurrencyInnerHtmlComponent {
}